<template>
  <div class="video-page">
    <autoplay-video>
      <source :src="videoMp4" type="video/mp4" />
      <source :src="videoWebm" type="video/webm" />
    </autoplay-video>
  </div>
</template>

<script>
import AutoplayVideo from "../components/AutoplayVideo";

export default {
  components: { AutoplayVideo },
  computed: {
    videoMp4() {
      return this.$store.state.videoDownloadURLs["Oath.mp4"];
    },
    videoWebm() {
      return this.$store.state.videoDownloadURLs["Oath.webm"];
    }
  }
};
</script>

<style lang="less">
</style>
